import { client } from '@/common-utils/libraries/axios/axios';
import { ORGANIZATION } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationUpdateSimAlertsSettings = (onSuccess, onError) => {
    return {
        mutationFn: ({ organizationId, settings }) => {
            return client.post(replaceParameters(ORGANIZATION.SIM_ALERTS.url, { uuid: organizationId }), { ...settings });
        },
        onError: (error) => {
            onError(error);
        },
        onSuccess: () => {
            onSuccess();
        },
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdateSimAlertsSettings;